import React, { ChangeEvent, useCallback, useRef, useState } from 'react'

import Section from '../../components/Section'
import CodeMirror from '../../components/CodeMirror'
import Button from '../../components/Button'

import './ParseSection.css'
import Input from '../../components/Input'
import toast from 'react-hot-toast'

interface ParseSectionProps {
    onChange: (value: string) => void
    onClear: () => void
    value: string
    onParse: () => void
    parseError: string | null
    onHandleParse: (value: string) => void
}

const ParseSection: React.FC<ParseSectionProps> = ({
    onChange,
    onClear,
    value,
    onParse,
    parseError,
    onHandleParse,
}) => {
    const [fileName, setFileName] = useState<string>('')
    const fileUpload = useRef<HTMLInputElement>(null)
    const uploadProfilePic = useCallback((e) => {
        const MAX_FILE_SIZE = 1000 * 1024
        if (e.target.files.length > 0) {
            const uploadedFileSize = e.target.files[0].size / 1024
            if (uploadedFileSize < MAX_FILE_SIZE) {
                const file = e.target.files[0] // you will get current uploaded value
                const reader = new FileReader()
                reader.onload = function (e) {
                    const contentString = reader.result
                    const content = JSON.parse(contentString as string)
                    if (Array.isArray(content)) {
                        setFileName(file.name)
                        const abi = JSON.stringify(content)
                        onChange(abi)
                        onHandleParse(abi)
                    } else if (Array.isArray(content.abi)) {
                        setFileName(file.name)
                        const abi = JSON.stringify(content.abi)
                        onChange(abi)
                        onHandleParse(abi)
                    } else {
                        toast.error('Invalid data!!')
                    }
                }
                reader.readAsText(file)
                e.currentTarget.value = null // this the place where we need to assign null value
            } else {
                toast.error('File too large!!')
            }
        }
    }, [])

    const handleUpload = () => {
        console.log(fileUpload.current?.click(), 'fileUpload')
    }
    return (
        <Section
            className="section-parse"
            title="Enter your contract's ABI or load from file to auto-parse"
        >
            <input
                type="file"
                ref={fileUpload}
                onChange={uploadProfilePic}
                style={{ opacity: '0' }}
                hidden
            />
            <Button hover onClick={() => handleUpload()}>
                Load abi
            </Button>
            <label className="file-name__label">{fileName}</label>
            <div className="input-field parse-input">
                <CodeMirror
                    value={value}
                    onChange={onChange}
                    placeholder={`Enter your ABI json  [{"inputs":[], "name":[], "type":"function"}]`}
                />
            </div>
            <div className="section-parse__buttons">
                {parseError && <label>Enter correct JSON</label>}
                <div>
                    <Button hover onClick={onClear}>
                        Clear
                    </Button>
                    <Button hover onClick={onParse}>
                        Parse
                    </Button>
                </div>
            </div>
        </Section>
    )
}

export default ParseSection
